import { t } from "i18next";
import { enqueueSnackbar } from "notistack";

import { apiClient } from "../../ApiClient";
import { BACKEND_METHOD_TO_INTEGRATION } from "../constants";
import { GetState, SetState, Store, StoreData } from "../types";

import { setIntegrationMethod } from "./setIntegrationMethod";

export const getIntegrationsData = (
  set: SetState<StoreData>,
  get: GetState<Store>
) => async (): Promise<boolean> => {
  const integrationId = get().integrationId;
  if (integrationId === undefined) {
    console.warn("Integration ID is undefined");
    return false;
  }
  try {
    const response = await apiClient.integrations.getIntegrationsId(integrationId);
    const integration = response.data;
    set(() => ({
      integration,
    }));

    const mappedMethod = integration.method
      ? BACKEND_METHOD_TO_INTEGRATION[integration.method]
      : undefined;
    setIntegrationMethod(set)(mappedMethod);
    return true;
  } catch (error) {
    enqueueSnackbar(t("error.title"));
    return false;
  }
};
